import { ModalContextProvider, ModuleLayout } from '@billy/design-system'
import React, { ReactElement } from 'react'

import { TransactionViewProvider } from '@features/transactions/contexts/transactionViewContext'
import { TransactionViewTrackingContext } from '@features/transactions/enums/transactionViewTrackingContext'
import { CurrentUserContextProvider } from '@modules-deprecated/app/user'

import { AccountSideActions } from './elements/AccountSideActions'
import { AccountTable } from './elements/AccountTable'
import { AccountTableActions } from './elements/AccountTableActions'
import { AccountTitle } from './elements/AccountTitle'

export const Account = (): ReactElement => (
  <ModuleLayout title={<AccountTitle />} sideActions={<AccountSideActions />}>
    <ModalContextProvider>
      <CurrentUserContextProvider>
        <TransactionViewProvider
          trackingContext={TransactionViewTrackingContext.AccountStatements}
          isEmberHashRoutedView
        >
          <AccountTableActions />
          <AccountTable />
        </TransactionViewProvider>
      </CurrentUserContextProvider>
    </ModalContextProvider>
  </ModuleLayout>
)
